import { useCallback, useEffect, useState } from "react";
import axios from "axios";

export const useCuarentenas = () => {
  const [tableData, setTableData] = useState([]);
  const [total, setTotal] = useState(0);
  const [error, setError] = useState(null);
  const [isDataFetching, setIsDataFetching] = useState(false);
  const [isFiltering, setIsFiltering] = useState(false);

  const [filterValue, setFilterValue] = useState({
    start_date: undefined,
    end_date: undefined,
    status: [], 
    type_quarantine: [], 
    specie: [],
    keyword: "",
  });

  const [fetchConfig, setFetchConfig] = useState({
    offset: 1,
    limit: 10,
    order: "DESC",
  });

  const fetchData = useCallback(async () => {
    setIsDataFetching(true);
    const { limit, order, offset } = fetchConfig;

    try {
      let response;
      const filters = {};

      if (filterValue.start_date) filters.start_date = filterValue.start_date;
      if (filterValue.end_date) filters.end_date = filterValue.end_date;
      if (filterValue.type_quarantine?.length)
        filters.type_quarantine = filterValue.type_quarantine;
      if (filterValue.specie?.length) filters.specie = filterValue.specie;
      if (filterValue.keyword) filters.keyword = filterValue.keyword;
      if (isFiltering) {
        response = await axios.post(
          `${process.env.REACT_APP_BASE_URL_QUARANTINE}/quarantine/filter-advanced`,
          { offset, limit, order, ...filters }
        );
      } else {
        response = await axios.get(
          `${process.env.REACT_APP_BASE_URL_QUARANTINE}/quarantine`,
          {
            params: {
              limit,
              offset,
              order,
              ...filters,
            },
          }
        );
      }

      const data = response.data.quarantines ?? [];
      const countRows = response.data.count ?? 0;

      data.forEach((item) => {
        item.sectorsNames = item.sectors?.map((s) => s.name).join(", ") || "";
        item.foodPlantsNames =
          item.foodPlants
            ?.map((fp) =>
              fp.name
                .replace("Planta Alimentos ", "")
                .replace(/\b\w/g, (char) => char.toUpperCase())
            )
            .join(", ") || "";
      });

      setTableData(data);
      setTotal(countRows);
    } catch (err) {
      console.error("Error cargando cuarentenas", err);
      setError(err);
      setTableData([]);
    } finally {
      setIsDataFetching(false);
    }
  }, [fetchConfig, filterValue, isFiltering]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    tableData,
    total,
    error,
    isDataFetching,
    fetchConfig,
    setFetchConfig,
    filterValue,
    setFilterValue,
    isFiltering,
    setIsFiltering,
  };
};
